import React from 'react';
import AboutUs from '../components/AboutUs';
import ContactForm from '../components/ContactForm';
import { useSEO } from '../hooks/useSEO';

const ChiSiamoPage: React.FC = () => {
  useSEO({
    title: 'Chi Siamo - Synergy Team e Mission',
    description: 'Scopri il team di Synergy e la nostra mission: rivoluzionare l\'approvvigionamento dei materiali edili attraverso l\'aggregazione degli ordini.',
    keywords: 'chi siamo synergy, team synergy, mission synergy, azienda edilizia, storia synergy, valori aziendali',
    ogTitle: 'Chi Siamo - Synergy Team e Mission',
    ogDescription: 'Scopri il team di Synergy e la nostra mission: rivoluzionare l\'approvvigionamento dei materiali edili.',
    canonicalUrl: 'https://synergyedilizia.com/chi-siamo',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Chi Siamo - Synergy",
      "description": "Pagina informativa sul team e la mission di Synergy",
      "mainEntity": {
        "@type": "Organization",
        "name": "Synergy",
        "description": "Piattaforma che rivoluziona l'approvvigionamento dei materiali edili attraverso l'aggregazione degli ordini"
      }
    }
  });

  return (
    <div className="pt-20 bg-white">
      <AboutUs />
      <ContactForm />
    </div>
  );
};

export default ChiSiamoPage;
